import Vue from 'vue';
import VueMq from 'vue-mq';
import App from './App.vue';
import vClickOutside from 'v-click-outside';
import ToggleButton from 'vue-js-toggle-button';
import PrettyCheckbox from 'pretty-checkbox-vue';
import VueAxios from 'vue-axios';
import router from './router';
import store from './store';
import axios from 'axios';

Vue.config.productionTip = false;

Vue.use(VueMq, {
    breakpoints: {
        // default breakpoints - customize this
        xs: 768,
        sm: 922,
        md: 1200,
        lg: Infinity
    }
});

Vue.use(require('vue-moment'));
Vue.use(vClickOutside);
Vue.use(ToggleButton);
Vue.use(PrettyCheckbox);
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = '/api';

Vue.filter('toCurrency', function(value) {
    if (typeof value !== 'number') {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

Vue.router = router;

Vue.use(require('@websanova/vue-auth'), {
    auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js')
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
